import { SingleKuenstler } from "@/types";
import { RichText } from "./StrapiComponents/RichText";
import Image from "next/image";
import { GetImageUrl } from "@/app/common/Utils";
import styles from "@/styles/Kuenstler.module.scss";
import StrapiImage from "./StrapiComponents/StrapiImage";

export const SingleKuenstlerComponent = ({ kuenstler }: { kuenstler: SingleKuenstler }) => {
	return (
		<article className={styles.singleKuenstler}>
			{kuenstler.image && (
				<div className={styles.kuenstlerImageHolder}>
					<StrapiImage className={styles.kuenstlerImage} media={kuenstler.image} format="medium" loadingType="lazy" />
				</div>
			)}
			<div className={`${styles.content} translate`}>
				<h1>{kuenstler.title}</h1>
				<RichText content={kuenstler.description} />
			</div>
		</article>
	);
};
